/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Table, Empty } from "antd";

const Datatable = ({ props, columns, dataSource, pagination }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const customEmpty = () => (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="" />
  );

  return (
    <Table
      key={props}
      className="table datanew dataTable no-footer"
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      locale={{
        emptyText: customEmpty(),
      }}
      pagination={
        pagination
          ? {
              ...pagination,
              locale: {
                jump_to: "Ir para",
                page: "Página",
                items_per_page: "/ página",
              },
            }
          : false
      }
    />
  );
};

export default Datatable;
